/**
 * <bk-sticky-buy-bar> — поява липкої панелі купівлі за прокруткою.
 *
 * Панель показується, коли основна кнопка «До кошика» пішла вгору за межі
 * екрана, і ховається знову, коли видно футер — щоб не перекривати його вміст
 * назавжди. Обидва стани рахує IntersectionObserver, слухачів scroll немає.
 *
 * Без залежностей; підключається з секції з атрибутом defer.
 */
class BkStickyBuyBar extends HTMLElement {
  #pastTrigger = false;
  #atFooter = false;
  #observers = [];

  connectedCallback() {
    const trigger = this.#resolve(this.dataset.trigger);
    const footer = this.#resolve(this.dataset.footer);

    // Немає за чим стежити — панель залишається схованою, а не висить завжди.
    if (!trigger) return;

    this.#observe(trigger, (entry) => {
      // Тригер вважається пройденим, лише коли він поїхав саме вгору.
      this.#pastTrigger = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    });

    if (footer) {
      this.#observe(footer, (entry) => {
        this.#atFooter = entry.isIntersecting;
      });
    }
  }

  disconnectedCallback() {
    for (const observer of this.#observers) observer.disconnect();
    this.#observers = [];
  }

  /**
   * Перший елемент за селектором, що не лежить усередині самої панелі.
   * @param {string | undefined} selector
   * @returns {Element | null}
   */
  #resolve(selector) {
    if (!selector) return null;

    for (const element of document.querySelectorAll(selector)) {
      if (!this.contains(element)) return element;
    }

    return null;
  }

  /**
   * @param {Element} element
   * @param {(entry: IntersectionObserverEntry) => void} onChange
   */
  #observe(element, onChange) {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;

        onChange(entry);
        this.#render();
      },
      { threshold: 0 }
    );

    observer.observe(element);
    this.#observers.push(observer);
  }

  #render() {
    this.dataset.visible = this.#pastTrigger && !this.#atFooter ? 'true' : 'false';
  }
}

if (!customElements.get('bk-sticky-buy-bar')) {
  customElements.define('bk-sticky-buy-bar', BkStickyBuyBar);
}
